import { queries as mq, updateHash, toggleVideoPlayBack } from '../utils/Utils';
import { setActiveMenuItem , setOffset, clearOffset, titleAnimation } from '../utils/ScrollUtils';

let horizontalScrollController = null;
let verticalScrollController = null;
let itemsController = null;

export const KristoffelScrollMagicController = () => {


  enquire.register(mq.desktop, {
    match: () => {
      horizontalScrollEvent();
      animateItemsIn();
    },
    unmatch: () => {
      horizontalScrollController.destroy(true);
      itemsController.destroy(true);
      clearOffset($('.animate'), null);
    },
  })

  enquire.register(mq.mobile, {
    match: () => {
      verticalScrollEvent();
    },
    unmatch: () => {
      verticalScrollController.destroy(true)
    },
  })

}



const animateItemsIn = () => {
  itemsController = new ScrollMagic.Controller({
    vertical: false,
    globalSceneOptions: {
      offset: 0,
      triggerHook: 0.9
    }
  });

  const $items = $('.animate');
  const $itemList = $('.animate-list');

  setOffset($items, null);

  $itemList.each((i, el) => {
    const $this = $(el);
    const offset = $this.attr('data-anim-offset');
    const $children = $this.find('.animate');

    setOffset($children, offset);
  })

  $items.each((i, el) => {
    let animScene = new ScrollMagic.Scene({
        triggerElement: el,
        // duration: ($(window).width() / 3)
      })
      .setTween(el, 1.5, { transform: 'translateX(0)', opacity: '1'})
      .setClassToggle(el, "completed")
      // .addIndicators({name: 'anim', colorStart: 'blue', colorEnd: 'red', colorTrigger: 'green'})
      .addTo(itemsController);

    // $(window).on('window:resize', (e) => {
    //   animScene.duration($(window).width() / 3);
    // })

    animScene.tweenChanges(true);
  })

}



export const horizontalScrollEvent = () => {
  horizontalScrollController = new ScrollMagic.Controller({
    vertical: false,
    globalSceneOptions: {
      offset: 0,
      triggerHook: 0.65
    }
  });

  const sections = $("#sidescroll section");

  // for (let i = 0; i < sections.length; i++) {
  sections.each((i, el) => {
    const title = $(el).attr('data-title');
    const id = $(el).attr('id');
    const $video = $(el).find('video');


    let scrollScene = new ScrollMagic.Scene({
        triggerElement: el,
        duration: $(el).outerWidth(true)
      })
      // .setTween(el, {backgroundColor: "rgba(0,0,0,1)"})
      .on("enter", (e) => {
        titleAnimation(title);
        setActiveMenuItem(id);
        updateHash(id);
        // toggleVideoPlayBack(e.type, $video);
      })
      // .addIndicators({name: "section", colorStart: "blue", colorEnd: "red", colorTrigger: "green"})
      .addTo(horizontalScrollController);

    // Update duration on window resize
    $(window).on("window:resize", (e) => {
      scrollScene.duration($(el).outerWidth(true));
    })
  })
}


const verticalScrollEvent = () => {
  verticalScrollController = new ScrollMagic.Controller({
    globalSceneOptions: {
      offset: 0,
      triggerHook: 0.35
    }
  });

  const sections = $("#sidescroll section");

  // for (let i = 0; i < sections.length; i++) {
  sections.each((i, el) => {
    const title = $(el).attr('data-title');
    const id = $(el).attr('id');
    const $video = $(el).find('video');


    let scrollScene = new ScrollMagic.Scene({
        triggerElement: el,
        duration: $(el).height()
      })
      // .setTween(el, {backgroundColor: "rgba(0,0,0,1)"})
      .on("enter", (e) => {
        titleAnimation(title);
        setActiveMenuItem(id);
        updateHash(id);
        toggleVideoPlayBack(e.type, $video);
      })

      // .addIndicators({name: "section", colorStart: "blue", colorEnd: "red", colorTrigger: "green"})
      .addTo(verticalScrollController);

    // Update duration on window resize
    $(window).on("window:resize", (e) => {
      scrollScene.duration($(el).height());
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/controllers/KristoffelScrollMagicController.js